import { useState } from 'react';
import PropTypes from 'prop-types';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

function UserProfile({ user, preferences }) {
  const [userPreferences, setUserPreferences] = useState(preferences);

  const handlePreferenceChange = async (category) => {
    let newPreferences;
    if (userPreferences.includes(category)) {
      newPreferences = userPreferences.filter(pref => pref !== category);
    } else {
      newPreferences = [...userPreferences, category];
    }

    setUserPreferences(newPreferences);

    try {
      const userRef = doc(db, 'users', user.uid);
      await updateDoc(userRef, {
        preferences: newPreferences
      });
      console.log('User preferences updated successfully');
    } catch (error) {
      console.error('Error updating user preferences:', error);
    }
  };

  return (
    <div className="user-profile">
      <h2>User Preferences</h2>
      <div className="preference-list">
        {['Politics', 'Global News', 'Business & Finance', 'Sports', 'Entertainment'].map((category) => (
          <label key={category}>
            <input
              type="checkbox"
              checked={userPreferences.includes(category)}
              onChange={() => handlePreferenceChange(category)}
            />
            {category}
          </label>
        ))}
      </div>
    </div>
  );
}

UserProfile.propTypes = {
  user: PropTypes.shape({
    uid: PropTypes.string.isRequired
  }).isRequired,
  preferences: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default UserProfile;